// extracted by mini-css-extract-plugin
module.exports = {"rounded-table":"HowBonusIsCalculated_rounded-table__sQ2rf"};